/* MFRMProductTypes enum is used to check/compare the product type with product_details cookie
by converting it to lower case used mainly in "conditional statements" */
export enum MFRMProductTypes {
    core = 'core',
    smallParcel = 'parcel',
    dropShip = 'drop ship'
}

// DeliveryModes enum is used to pass the modOfDelivery value in "API payloads"
export enum DeliveryModes {
    core = 'Delivery',
    smallParcel = 'Parcel',
    dropShip = 'Drop Ship'
}

// coreItemShippingType constant value is used to compare the shipping type of core products
export const coreItemShippingType = 'delivery';